import 'es6-promise/auto'
import '@/utils/configuration'
import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import '@fortawesome/fontawesome-free-webfonts/css/fontawesome.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-regular.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-solid.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-brands.css'
import VueSilentbox from 'vue-silentbox'
import VueTimeago from 'vue-timeago'
import VeeValidate from 'vee-validate'

import '@/css/app.css'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import '@/api'
import globalParamsMixin from './mixins/GlobalParamsMixin'
import AuthMixin from './mixins/AuthMixin'
import VueProgressBar from 'vue-progressbar'
import ReadMore from 'vue-read-more'

Vue.use(Buefy, {
  defaultIconPack: 'fas'
})
Vue.use(Vue2Filters)
Vue.use(VueSilentbox)

Vue.use(require('vue-moment'))

Vue.use(VueTimeago, {
  name: 'timeago',
  locale: 'en-US',
  locales: {
    'en-US': require('vue-timeago/locales/en-US.json')
  }
})

Vue.use(VeeValidate, {
  events: ''
})

Vue.use(VueProgressBar, {
  color: '#257de2',
  failedColor: 'red',
  thickness: '10px',
  transition: {
    speed: '0.4s',
    opacity: '0.6s',
    termination: 300
  },
  autoFinish: true
})

Vue.use(ReadMore)

Vue.config.productionTip = false

Vue.filter('capitalize_all', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('currency', function (price, currency) {
  return parseFloat(price).toFixed(2) + ' ' + currency
})

Vue.filter('prettyBytes', function (num) {
  // jacked from: https://github.com/sindresorhus/pretty-bytes
  // jacked from: https://gist.github.com/james2doyle/4aba55c22f084800c199
  num = parseInt(num)
  if (typeof num !== 'number' || isNaN(num)) {
    throw new TypeError('Expected a number')
  }
  var exponent
  var unit
  var neg = num < 0
  var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  if (neg) { num = -num }
  if (num < 1) { return (neg ? '-' : '') + num + ' B' }
  exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1)
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1
  unit = units[exponent]
  return (neg ? '-' : '') + num + ' ' + unit
})

Vue.mixin(globalParamsMixin)
Vue.mixin(AuthMixin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
